import type { Route } from '~/interfaces/routes.interfaces'
import { BASE_URL_QUICK_ACCESS } from '~/constants/routes/quick-access/routes.constants'

const base = `${BASE_URL_QUICK_ACCESS}/press-review`

export const QUICK_ACCESS_PRESS_REVIEW: Route = {
  path: base
}

export const QUICK_ACCESS_PRESS_REVIEW_VIEW: Route = {
  path: `${base}/customer/{id_customer}/press-review/{id}`
}

export const QUICK_ACCESS_PRESS_REVIEW_CUSTOMER_VIEW: Route = {
  path: `${base}/customer/{id}`
}

export const QUICK_ACCESS_PRESS_REVIEW_CUSTOMER_VIEW_GO_TO_FIRST_WITH_DATE: Route = {
  path: `${base}/customer/{id}?go_to_first=1&date={date}`
}

export const QUICK_ACCESS_PRESS_REVIEW_CUSTOMER_FROM_PRESS_REVIEW_ISSUE_WITH_DATE: Route = {
  path: `${base}/customer/{id}?from_press_review_issue_id={id_press_review_issue}&date={date}`
}
